import { uiCapabilityGrantedByRoles } from "@/helpers/capabilities";
import { complianceProducts } from "@/modules/organization/sellable-modules";
import Vue from "vue";
import { Products, ScopedProducts } from "../modules/products/products";
const localizedFields = ["name", "description", "regulation", "kvkkRegulation", "gdprRegulation", "doneReason"];

Vue.mixin({
  computed: {
    products() {
      return [...Products];
    },
    scopedProducts() {
      return [...ScopedProducts];
    },
    currentLanguage() {
      return this.$store.getters["user/account"]?.language ?? "tr";
    },
    currentAccount() {
      return this.$store.getters["user/account"];
    },
    currentAccountDepartments() {
      return this.$store.getters["user/account"]?.adminEntities?.departments || [];
    },
    currentAccountProcesses() {
      return this.$store.getters["user/account"]?.adminEntities?.Processes || [];
    },
    currentRoles() {
      return this.$store.getters["organization/selected"]?.roles ?? [];
    },
    currentOrganization() {
      return this.$store.getters["organization/selected"];
    },

    currentWorkspace() {
      return this.$store.getters["switchWorkspace/selected"];
    },
    currentProduct() {
      return this.$store.getters["product/currentProduct"];
    },
    accessableProducts() {
      // TKP-87: Görevler (TASKS) satılabilir modül ama uyum ürünü değil — ürün seçimlerinde sunulmaz.
      return complianceProducts(this.currentOrganization?.features?.accessableProducts, { excludeRisk: true });
    },
    isOrganizationOwner() {
      return this.currentAccount?._id == this.currentOrganization?.createdBy?._id;
    },
    isWorkspaceAdmin() {
      return this.currentWorkspace?.role.definition == "WORKSPACE_ADMIN" || this.currentWorkspace?.owner._id == this.currentAccount._id;
    },
    isAdminOfWorkspace(workspace) {
      return workspace?.role.definition == "WORKSPACE_ADMIN" || workspace?.owner._id == this.currentAccount._id;
    },
    isAdminOrOwnerOfAnyWorkpace() {
      return this.$store.getters["user/isAdminOrOwnerOfAnyWorkpace"];
    },

    whiteLabel() {
      return this.$store.getters["clientConfig/whiteLabel"];
    },
  },
  methods: {
    //çoklu dilde bakcendten gelen name:Localized için formda name:string olması gerekiyor.
    //bunun için backendten gelen entityleri forma yansıtmadan önce bu metod kullanılıyor
    //name dışında fieldlarda da işlem yapılması gerektiğinde ikinci bir parametre ile field listesi alınabilir.
    prepareFormForEdit(item, fields = []) {
      const response = { ...item };

      [...localizedFields, ...fields].forEach((field) => {
        if (!response[field]) {
          return;
        }
        if (Array.isArray(response[field])) {
          response[field] = response[field].map((entry) => {
            return {
              ...entry,
              name: entry.name?.[this.currentLanguage] || entry.name,
            };
          });
        } else {
          response[field] = response[field][this.currentLanguage];
        }
      });
      return response;
    },

    // TKP-97: yetki listesi elle yazılmaz; adlandırılmış arayüz yeteneği sorulur (`helpers/capabilities.js`).
    currentAccountCan(capability) {
      if (this.isOrganizationOwner) return true;
      return uiCapabilityGrantedByRoles(this.currentRoles, capability);
    },

    hasCurrentOrganizationAccessable(product) {
      return this.hasOrganizationAccessableForProduct(this.currentOrganization, product);
    },
    hasCurrentOrganizationAccessableForFeature(feature) {
      return !!this.currentOrganization?.features?.[feature];
    },
    hasOrganizationAccessableForProduct(organization, product) {
      return organization?.features?.accessableProducts?.includes(product);
    },

    async selectOrganizationAndGo(organization, path, newPage = false) {
      await this.$store.dispatch("organization/selected", { ...(organization?._id ? organization : { _id: organization }) });
      await this.$store.dispatch("synchronization/sync");
      if (newPage) {
        window.open(path, "_blank");
      } else {
        window.location.href = path;
      }
    },

    regulationSelectorByProduct(legalReason) {
      const product = this.$store.getters["product/currentProduct"];
      if (product == "KVKK") {
        return legalReason.kvkkRegulation;
      } else {
        return legalReason.gdprRegulation;
      }
    },
  },
});
